import { apiRequest } from "./client";

export async function getTenantStaff() {
  const response = await apiRequest("/api/v1/staff");
  return response.json();
}

export async function postStaff(staff) {
  const response = await apiRequest("/api/v1/staff", {
    method: "POST",
    body: JSON.stringify(staff),
  });
  return response.json();
}

export async function deleteStaff(staffPublicId) {
  const response = await apiRequest(`/api/v1/staff/${staffPublicId}`, {
    method: "DELETE",
  });
  return response.json();
}

export async function getActiveStaff() {
  const response = await apiRequest("/api/v1/staff/active");
  return response.json();
}
